import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import { Grid } from 'react-bootstrap'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { styles } from './styles'
import NoShowTrackerTable from './components/NoShowTrackerTable'
import { NO_SHOW_TRACKER_HEADERS } from './options'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { readNoShowMissionLog } from '../../gql'
import { isArray } from 'lodash'
import { useSortData } from '../../../../../../Utils/Hooks/useSortData'
import { useHistory } from 'react-router-dom'

const getTimeOfTheDay = date => {
  const [, hour, am_pm] = moment(date)
    .format('dddd,h,A')
    .split(',')
  let dateOut

  if (am_pm === 'AM') {
    dateOut = `Morning`
  } else {
    if (hour === 12 || hour < 6) {
      dateOut = `Afternoon`
    } else {
      dateOut = `Evening`
    }
  }
  return dateOut
}

const NoShowTrackerSection = ({ ambassador, classes }) => {
  const history = useHistory()
  const { data: noShowMissionLogsData, isLoaded } = useGraphQLFetch({
    fetchFn: readNoShowMissionLog,
    defaultFetchArgs: { userId: ambassador.id },
    mapResponse: ({ readNoShowMissionLog }) =>
      readNoShowMissionLog.map(
        ({ campaign, date, city, location, mission }) => ({
          missionId: mission.id,
          campaign: campaign ? campaign.name : '-',
          date: moment(date)
            .tz(ambassador.city.timezone)
            .format('DD/MM/YYYY hh:mm A'),
          week: moment(date).isoWeek(),
          time: getTimeOfTheDay(date),
          city: city ? city.name : '-',
          location: location ? location.name : '-',
        }),
      ),
  })
  const { data, orderBy, order, onSort } = useSortData({
    orderBy: 'date',
    data: noShowMissionLogsData,
  })

  const onSortHandler = property => () => onSort(property)
  const onTableItemClick = item =>
    history.push(`/dashboard/mission/${item.missionId}`)

  if (isArray(noShowMissionLogsData) && !noShowMissionLogsData.length)
    return null

  return (
    <AmbassadorSection>
      <Grid fluid>
        <div className={classes.title}>No-show tracker</div>
        <NoShowTrackerTable
          headers={NO_SHOW_TRACKER_HEADERS}
          data={data}
          isLoading={!isLoaded}
          orderBy={orderBy}
          order={order}
          onSort={onSortHandler}
          onClickItem={onTableItemClick}
        />
      </Grid>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(NoShowTrackerSection)
